
import _ from "lodash";
import Guard from "../common/guard";
import { IUserEndPoint, IGetUserEndPoint,ISAPOrder } from "../models/applicationState";
import ServiceHelper from "./serviceHelper";
import { toast } from "react-toastify";
import { headers, loadEndPoint, loadEndPointByUser, enableDisableEndPoint, createUserEndPoint, 
    deleteEndPoint, accessToken, refreshTokenEndPoint, refreshTokenCall,createSAPOrderEndPoint ,
    loadBusinessUsersEndPoint,loadBusinessUsersByIdEndPoint} from "../common/api-config";
export interface IUserDefinedService {
    loadEndPoints(): Promise<void>;
    loadListofBusinessUsers(): Promise<void>;
}

export class UserDefinedService {
    /**
     * Get load Ned Points
     */
    public loadEndPoints = async (endPoint: IGetUserEndPoint) => {
        Guard.null(endPoint);
        //const endpointURL = loadEndPoint(endPoint)
        const endpointURL = loadEndPointByUser(endPoint);
         
        let response;
        let headers = accessToken()
        let data = {}
        try {
            response = await ServiceHelper.postWithAutoRetry(
                endpointURL, data, { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.postWithAutoRetry(
                            endpointURL, data, { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }
                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }
    /**
     * Enable and disabled end points
     */
    public enableDisableEndPoint = async (endPoint: IGetUserEndPoint) => {
        Guard.null(endPoint);
        const endpointURL = enableDisableEndPoint(endPoint)
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.getWithAutoRetry(
                endpointURL, { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            endpointURL, { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }
                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }
    /**
     * Create User End Point
     */
    public createUserEndPoint = async (endPoint: IUserEndPoint, body) => {
        Guard.null(endPoint);
        const endpointURL = createUserEndPoint(endPoint)
        let headers = accessToken()
        let response;
        try {
            response = await ServiceHelper.postWithAutoRetry(
                endpointURL, body, { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.postWithAutoRetry(
                            endpointURL, body, { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }
                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }
    /**
     * Create User End Point
     */
    public deleteEndPoint = async (endPoint: IGetUserEndPoint) => {
        Guard.null(endPoint);
        const endpointURL = deleteEndPoint(endPoint)
        let headers = accessToken()
        let response;
        try {
            response = await ServiceHelper.getWithAutoRetry(
                endpointURL, { headers });
            return response.data;
        } catch (err) {
            // ServiceHelper.handleServiceError(err);
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            endpointURL, { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }
                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }


    /**
     * Create User End Point
     */
    public createSAPOrder = async (sapOrder: ISAPOrder, body) => {
        Guard.null(sapOrder);
        const endpointURL = createSAPOrderEndPoint(sapOrder)
        let headers = accessToken()
        let response;
        try {

            
/*
body["project_name"] = sapOrder.project_name+"-"+this.getUserId();
          
body["invoice_no"] =  sapOrder.invoiceNo?sapOrder.invoiceNo:"11";
body["purchase_req"] = sapOrder.purchaseReq ;
          
body["user_id"] =  this.getUserId();;
body["status"]=sapOrder.status;
*/
 

            response = await ServiceHelper.postWithAutoRetry(
                endpointURL, body, { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.postWithAutoRetry(
                            endpointURL, body, { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }
                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    public getUserId = () => {
        const signInUserSession = localStorage.getItem("signInUserSession");
        const user = signInUserSession && JSON.parse(signInUserSession);
        const userId = user && user.user.oid;
        return userId;
    };
    
    
    public loadListofBusinessUsers = async () => {
        //Guard.null(endPoint);
        //const endpointURL = loadEndPoint(endPoint)
        //const endpointURL = loadEndPointByUser();
        const endpointURL = loadBusinessUsersEndPoint();
         
        let response;
        let headers = accessToken();
        let data = {}
        try {
            response = await ServiceHelper.postWithAutoRetry(
                endpointURL, data, { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.postWithAutoRetry(
                            endpointURL, data, { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }
                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }
    
    
    public getBusinessUserDetailsbyId = async (useroid:string) => {
      
        const endpointURL = loadBusinessUsersByIdEndPoint(useroid);
         
        let response;
        let headers = accessToken();
        let data = {}
        try {
            response = await ServiceHelper.postWithAutoRetry(
                endpointURL, data, { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.postWithAutoRetry(
                            endpointURL, data, { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }
                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

}
